import http from './httpService';

export function getCurrentUser() {
  return http.get(`/account`);
}

export function getDepartmentsCurrentUser() {
  return http.get(`/departments-login-user`);
}

export function getAppInfo() {
  return http.get(`/about-app`);
}